import React, { memo } from 'react';
import { Dropdown, Menu, Tooltip } from 'antd';
import { MoreOutlined } from '@ant-design/icons';

function GroupTitleCell({ title, onEdit, onCopy, onDelete, showMemberList }) {
  const menu = (
    <Menu>
      {onEdit ? <Menu.Item onClick={onEdit}>Edit Group Name</Menu.Item> : null}
      {onCopy ? (
        <Menu.Item onClick={onCopy}>Copy all Group Emails</Menu.Item>
      ) : null}
      {showMemberList ? (
        <Menu.Item onClick={showMemberList}>Show all Group Members</Menu.Item>
      ) : null}
      {onEdit ? (
        <Menu.Item onClick={onDelete} style={{ color: 'var(--activeColor)' }}>
          Delete Group
        </Menu.Item>
      ) : null}
    </Menu>
  );
  return (
    <div className="group-title-cell">
      <div className="group-title-text">
        <Tooltip
          title={title}
          overlayClassName="group-title-cell-tooltip"
          key={title}
          align={{
            useCssRight: true,
            useCssTransform: true,
            points: ['bc', 'tc'],
            overflow: { adjustX: false, adjustY: true, alwaysByViewport: true },
          }}
        >
          {title}
        </Tooltip>
      </div>
      <Dropdown overlay={menu} placement="bottomRight">
        <MoreOutlined className="group-dropdown-icon" />
      </Dropdown>
    </div>
  );
}

export default memo(GroupTitleCell);
